// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mySwiper {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.mySwiper.disabled {
  opacity: 0.5;
}

.swiper-slide {
  text-align: center;
  font-size: 14px;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  height: calc(100vh - 60px); /* Adjust this value based on your bottom bar height */
}

.swiper-slide.swiper-slide-active {
  display: flex;
  opacity: 1;
  height: calc(100vh - 60px);
}

.swiper-slide-content {
  overflow-y: auto;
  width: 100%;
  margin: 10px 0; /* Add margin to make space for arrows */
}

.swiper-slide-prev,
.swiper-slide-next {
  opacity: 0.15;
}

.swiper-button-next,
.swiper-button-prev {
  width: 30px !important;
  height: 30px !important;
  color: rgba(255, 255, 255, 0.6) !important;
  transition: all 0.2s ease;
  right: 10px !important;
  left: auto !important;
  margin: 0 !important;
  z-index: 10;
}

.swiper-button-next {
  bottom: -12px !important;
  top: auto !important;
  transform: rotate(90deg);
}

.swiper-button-prev {
  top: -12px !important;
  transform: rotate(90deg);
}

.swiper-button-next:hover,
.swiper-button-prev:hover {
  color: rgba(255, 255, 255, 0.9) !important;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  font-size: 14px !important;
  font-weight: bold;
}

.swiper-button-disabled {
  opacity: 0 !important;
  cursor: default;
}

/* Add styles for disabled state */
[style*="pointer-events: none"] {
  opacity: 0.5;
}

.actionButton:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

@media (max-width: 480px) {
  .swiper-slide,
  .swiper-slide.swiper-slide-active {
    padding: 0;
    height: calc(100vh - 120px); /* Adjust for mobile bottom bar */
  }

  .swiper-slide-content {
    height: calc(100% - 50px);
    margin: 35px 0; /* Slightly smaller margin for mobile */
  }

  .swiper-button-next,
  .swiper-button-prev {
    width: 24px !important;
    height: 24px !important;
    right: 5px !important;
  }

  .swiper-button-next {
    bottom: 5px !important;
  }

  .swiper-button-prev {
    top: 5px !important;
  }

  .swiper-button-next::after,
  .swiper-button-prev::after {
    font-size: 12px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/audiocall/AutoDetect/MessageSlider.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,0BAA0B,EAAE,sDAAsD;AACpF;;AAEA;EACE,aAAa;EACb,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc,EAAE,wCAAwC;AAC1D;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE;;IAEE,UAAU;IACV,2BAA2B,EAAE,iCAAiC;EAChE;;EAEA;IACE,yBAAyB;IACzB,cAAc,EAAE,uCAAuC;EACzD;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":[".mySwiper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.mySwiper.disabled {\n  opacity: 0.5;\n}\n\n.swiper-slide {\n  text-align: center;\n  font-size: 14px;\n  background: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0;\n  height: calc(100vh - 60px); /* Adjust this value based on your bottom bar height */\n}\n\n.swiper-slide.swiper-slide-active {\n  display: flex;\n  opacity: 1;\n  height: calc(100vh - 60px);\n}\n\n.swiper-slide-content {\n  overflow-y: auto;\n  width: 100%;\n  margin: 10px 0; /* Add margin to make space for arrows */\n}\n\n.swiper-slide-prev,\n.swiper-slide-next {\n  opacity: 0.15;\n}\n\n.swiper-button-next,\n.swiper-button-prev {\n  width: 30px !important;\n  height: 30px !important;\n  color: rgba(255, 255, 255, 0.6) !important;\n  transition: all 0.2s ease;\n  right: 10px !important;\n  left: auto !important;\n  margin: 0 !important;\n  z-index: 10;\n}\n\n.swiper-button-next {\n  bottom: -12px !important;\n  top: auto !important;\n  transform: rotate(90deg);\n}\n\n.swiper-button-prev {\n  top: -12px !important;\n  transform: rotate(90deg);\n}\n\n.swiper-button-next:hover,\n.swiper-button-prev:hover {\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n\n.swiper-button-next::after,\n.swiper-button-prev::after {\n  font-size: 14px !important;\n  font-weight: bold;\n}\n\n.swiper-button-disabled {\n  opacity: 0 !important;\n  cursor: default;\n}\n\n/* Add styles for disabled state */\n[style*=\"pointer-events: none\"] {\n  opacity: 0.5;\n}\n\n.actionButton:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n  transform: scale(1.05);\n}\n\n@media (max-width: 480px) {\n  .swiper-slide,\n  .swiper-slide.swiper-slide-active {\n    padding: 0;\n    height: calc(100vh - 120px); /* Adjust for mobile bottom bar */\n  }\n\n  .swiper-slide-content {\n    height: calc(100% - 50px);\n    margin: 35px 0; /* Slightly smaller margin for mobile */\n  }\n\n  .swiper-button-next,\n  .swiper-button-prev {\n    width: 24px !important;\n    height: 24px !important;\n    right: 5px !important;\n  }\n\n  .swiper-button-next {\n    bottom: 5px !important;\n  }\n\n  .swiper-button-prev {\n    top: 5px !important;\n  }\n\n  .swiper-button-next::after,\n  .swiper-button-prev::after {\n    font-size: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
